import differenceInSeconds from 'date-fns/differenceInSeconds';

export function getDateDifference({
  dateLeft,
  dateRight,
}: {
  dateLeft: Date;
  dateRight: Date;
}): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalSeconds: number;
} {
  const totalSeconds = differenceInSeconds(dateLeft, dateRight);
  if (totalSeconds <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalSeconds: 0,
    };
  } else {
    return {
      days: Math.floor(totalSeconds / SECONDS_OF_A_DAY),
      hours: Math.floor((totalSeconds % SECONDS_OF_A_DAY) / SECONDS_OF_AN_HOUR),
      minutes: Math.floor((totalSeconds % SECONDS_OF_AN_HOUR) / 60),
      seconds: totalSeconds % 60,
      totalSeconds,
    };
  }
}

const SECONDS_OF_A_DAY = 60 * 60 * 24;
const SECONDS_OF_AN_HOUR = 60 * 60 * 1;
